<div class="full-height flex-row flex-center">
  <mat-icon [svgIcon]="getIconNameForDataUnitSetupCatalogStatus()" [class.cancelled-icon]="isCancelledIcon()" class="flex-no-shrink"></mat-icon>
</div>
